import { FunctionComponent, ReactNode } from "react";
import { Layout } from "antd";
import { useAuth } from "../../hooks/AuthContext";
import { PublicHeader } from "./PublicHeader";
import { PublicFooter } from "./PublicFooter";
import { AppShell } from "./AppShell";

const { Content } = Layout;

interface AppLayoutProps {
    children: ReactNode;
}

export const AppLayout: FunctionComponent<AppLayoutProps> = ({ children }) => {
    const { username } = useAuth();

    if (username) {
        return <AppShell>{children}</AppShell>;
    }

    return (
        <Layout className="public-layout" style={{ minHeight: "100vh" }}>
            <PublicHeader />
            <Content className="content">{children}</Content>
            <PublicFooter />
        </Layout>
    );
};
